/** Short, polite notifications. Anything can raise one through the bus: bus.emit('toast', {message, icon}). */
import { bus } from '../core/bus.js';
import { html, toHtml } from '../core/html.js';
import { ic } from './components.js';

const MAX_VISIBLE = 3;
const DURATION_MS = 3600;

export function toast(message, icon = 'check') {
  bus.emit('toast', { message, icon });
}

export function installToasts() {
  const host = document.getElementById('toasts');
  if (!host) return;
  host.setAttribute('aria-live', 'polite');
  bus.on('toast', ({ message, icon = 'check' }) => {
    const el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', icon === 'alert' ? 'alert' : 'status');
    el.innerHTML = toHtml(html`${ic(icon)}<span>${message}</span>`);
    host.append(el);
    while (host.children.length > MAX_VISIBLE) host.firstElementChild.remove();
    setTimeout(() => el.remove(), DURATION_MS);
  });
}
